// extracted by mini-css-extract-plugin
export var parcelRow = "_sj-0";